export const enum STAKING_STAGES {
  DEPOSIT = "deposit",
  PENDING = "pending",
  SENT = "sent",
}
